
 <!--
  11/06/2021
  Cambio Importante en el proceso de reserva.
  A partir de ahora, primero se cobra y despues se harán las reservas en las bases de datos
  de la web y del parking.

  Esto se debe a que algún usuario consigue cancelar el proceso de reserva (no realiza el pago)
  de un modo no controlado, lo que deja creada las reservas en ambas BD.

  No se si depende del navegador o del dispositivo (PC ó Móvil).

  Al cambiar el orden, la generacion de las reservas se delega al proceso de la notificacion de 
  la pasarela

  El orden de las operaciones es:

WEB
1) Compruebo los datos que ha introducido el usuario
2) Guardo en la tabla reservas los datos. El estado es -1 (indeterminado). NO hay informacion 
   de la reserva en el parking por que aún no se ha hecho.
3) Obtengo la URL de pago. Guardo en el campo de concepto el id de reserva y el parking 
   (aunque sea redundante)
4) Ejecuto el iframe.

BACKEND
5) Si el usuario finaliza el pago, se entra en el php de proceso de notificaciones.
6) Si el pago es correcto, recupero la reserva indicada en el concepto del pago. 
7) Comunico con el parking para realizar la reserva. 
8) Actualizo la reserva con los datos del pago y los recibidos del parking. El estado cambia 
   a 0 (pagado).
9) Continuo con el proceso ya existente de facturas.




-->  


<template>

    <!--  
    ************************************************
    Area de proceso de pago e informacion de reserva 
    ************************************************
    -->  
    <v-container fluid>
      <v-row>      
        <v-col class="col-sm-8"> <!-- media fila izq. stepper del proceso de reserva -->

            <template v-if="(tituloPagina == '') && (procesoPago < 3)"> 
              <v-row cols="auto" class="mr-auto ml-auto infoTiempoReserva" align="center" justify="center">
                {{ $t('tiempoRestanteParaFinalizarReserva') + countDown }}
              </v-row>
            </template>

            <v-stepper v-model="procesoPago"> <!-- stepper -->
              <v-stepper-header> <!-- Cabecera del stepper "proceso de reserva" -->
                <v-stepper-step :complete="procesoPago > 1" step="1">{{ $t('stepperComprobarDatos') }}</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="procesoPago > 2" step="2">{{ $t('steperRealizarPago') }}</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3">{{ $t('stepperResultadoProceso') }}</v-stepper-step>
              </v-stepper-header> <!-- Cabecera del stepper "proceso de reserva" -->

              <v-stepper-items>
                <v-stepper-content step="1" height="100%" no-gutters> <!-- step 1 "Datos de usuario" -->
                    
                  <form style="background-color: inherit">
                      <div class="form-group entradaDatosUnico" >
                          <label for="nombre" style="margin-top: 10px;">{{ $t('datosReservaNombre') }}</label>
                          <input type="text" v-model="datosReserva.nombre" id="nombre" name="nombre" class="form-control" :class="{ 'is-invalid': submitted && $v.datosReserva.nombre.$error }" />
                          <div v-if="submitted && !$v.datosReserva.nombre.required" class="invalid-feedback">
                            {{ $t('errorNoNombre') }}
                          </div>
                      </div>

                      <div class="form-group entradaDatosUnico">
                          <label for="mail">{{ $t('datosReservaEmail') }}</label>
                          <input type="email" v-model="datosReserva.mail" id="mail" name="mail" class="form-control" :class="{ 'is-invalid': submitted && $v.datosReserva.mail.$error }" />
                          <div v-if="submitted && !$v.datosReserva.mail.required" class="invalid-feedback">
                            {{ $t('errorNoEmail') }}
                          </div>
                          <div v-if="submitted && !$v.datosReserva.mail.email" class="invalid-feedback">
                            {{ $t('errorEmailErroneo') }}
                          </div>
                      </div>
            
                      <div class="form-group entradaDatosUnico">
                          <label for="telefono">{{ $t('datosReservaTelefono') }}</label>
                          <input type="text" v-model="datosReserva.telefono" id="telefono" name="telefono" class="form-control" :class="{ 'is-invalid': submitted && $v.datosReserva.telefono.$error }" />
                          <div v-if="submitted && !$v.datosReserva.telefono.required" class="invalid-feedback">
                          {{ $t('errorNoTelefono') }}
                          </div>
                      </div>         

                      <div class="form-group form-check entradaDatosUnico">
                          <input type="checkbox" v-model="datosReserva.aceptacionTerminos"
                              @change="$v.datosReserva.aceptacionTerminos.$touch()" id="accept" 
                              class="form-check-input">
                          <label class="form-check-label" 
                                :class="{ 'is-invalid': submitted && $v.datosReserva.aceptacionTerminos.$error }" 
                                for="accept">{{ $t('datosReservaAceptoCondiciones') }}</label>

                          <div v-if="submitted && $v.datosReserva.aceptacionTerminos.$error" class="invalid-feedback">
                              <span v-if="!$v.datosReserva.aceptacionTerminos.required">
                                {{ $t('errorNoAceptaTerminos') }}
                              </span>
                          </div>
                      </div>


                  </form> <!-- fin formulario datos obligatorios de usuario -->

                
                  <!-- <div class="entradaDatosUnico_"> -->
                    <v-expansion-panels  style="margin-top: 16px">
                      <v-expansion-panel style="margin-bottom: 7px">
                        <v-expansion-panel-header class="body-2" style="color: white; background: #1ab9e4">
                          {{ $t('datosReservaInformacionFacturacion') }}
                        </v-expansion-panel-header>

                        <v-expansion-panel-content class="body-2" style="margin-top: 16px; font-weight: 300;">

                          <div class="form-group_ entradaDatosUnico_">
                                <label for="nombrefac">{{ $t('datosReservaNombreFac') }}</label>
                                <input type="text" v-model="datosReserva.nombreFac" id="nombrefac" name="nombrefac" class="form-control" />
                          </div>         
                          <div class="form-group entradaDatosUnico">
                                <label for="cif">{{ $t('datosReservaCif') }}</label>
                                <input type="text" v-model="datosReserva.cif" id="cif" name="cif" class="form-control"/>
                          </div>         
                          <div class="form-group entradaDatosUnico">
                                <label for="direccion">{{ $t('datosReservaDireccion') }}</label>
                                <input type="text" v-model="datosReserva.direccion" id="direccion" name="direccion" class="form-control"/>
                          </div>         
                          <div class="form-group entradaDatosUnico">
                                <label for="localidad">{{ $t('datosReservaLocalidad') }}</label>
                                <input type="text" v-model="datosReserva.localidad" id="localidad" name="localidad" class="form-control"/>
                          </div>         
                          <div class="form-group entradaDatosUnico">
                                <label for="cp">{{ $t('datosReservaCp') }}</label>
                                <input type="text" v-model="datosReserva.cp" id="cp" name="cp" class="form-control"/>
                          </div>         
                        
                        
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  <!-- </div> fin area datos de facturacion -->

                  <v-overlay v-model="dialog">
                    <v-progress-circular  
                      size="120"
                      width="12"                       
                      color="red"
                      indeterminate
                      justify="center" 
                      align="center">
                    </v-progress-circular>
                  </v-overlay>

                  <v-alert class="entradaDatosUnico" style="margin-bottom:10px;"
                        :value="alerta.mostrar"
                        color="pink"
                        dark
                        border="top"
                        icon="mdi-home"
                        transition="scale-transition">
                    {{ this.alerta.texto }}
                  </v-alert> <!-- para mostrar mensaje de error de comunicacion -->

                  <div class="entradaDatosUnico" style="margin-top:20px;">
                    <v-btn
                      class="mx-auto white--text"
                      color="#f08823"
                      @click="comprobarDatosUsuario()">
                      {{ $t('btnContinuar') }}
                    </v-btn>
                  </div>

                </v-stepper-content> <!-- fin step 1 "Datos de usuario" -->

                <v-stepper-content step="2" height="100%"> <!-- step 2 "iframe pago" -->
                    <v-row justify="center">
                      <v-col align="center" cols="auto">
                        <v-row justify="center" align="baseline">
                          <font-awesome-icon class="awesome" :icon="['fas', 'lock']" />
                          <label style="margin-left: 5px"> {{ $t('pagoseguro') }} </label>
                        </v-row>
                        <v-row justify="center">
                          <v-img class="ml-2" style="vertical-align: middle; display: inline-block" src="@/assets/paycomet.png" max-width="150" max-height="60" contain></v-img>
                        </v-row>
                        <v-row justify="center">
                          <v-img class="ml-2" style="vertical-align: middle; display: inline-block" src="@/assets/tarjetas.png" width="150" max-height="30" contain></v-img>
                        </v-row>
                        <v-row style="margin: 0px; padding: 0px;">
                          <iframe width="100%" height="350px" style="padding: 10px; background-color:white;" 
                                  id="iframePago"
                                  name="iframePago"
                                  ref="iframePago"
                                  
                                  sandbox="allow-forms allow-top-navigation allow-same-origin allow-scripts"
                                  @load="paginaFrameCargada(this)"
                                  :src="urlPago"></iframe> 
                        </v-row>
                      </v-col>
                    </v-row>
          
        
                  <!-- muestra un boton u otro en funcion del titulo de la página web cargada en 
                       el iFrame. Sirve para detectar cuando se recibe la urlok o urlko -->
                  <template v-if="((tituloPagina == 'operacionok') || (tituloPagina == 'operacionko'))"> 
                    <v-btn 
                      style="margin-top:20px;"
                      class="mx-auto white--text"
                      color="#f08823"
                      @click="finalizarReserva()" 
                    >
                      {{ $t('btnContinuar') }}
                    </v-btn>

                  </template>
                  <template v-else>
                    <v-btn 
                      style="margin-top:20px;"
                      class="mx-auto white--text"
                      color="#f08823"
                      @click="cancelarReservaEnCurso()" 
                    >
                     {{ $t('btnCancelar') }}
                    </v-btn>
                  </template>

                </v-stepper-content>  <!-- fin step 2 "iframe pago" -->

                <v-stepper-content step="3">  <!-- step 3 "reserva realizada" -->
                  
                    <!-- OJO. Esta repetido el estilo como class y style por que, sino se incluye style, 
                    a la hora de imprimir los textos quedan feos -->
                    
                    <div class="infoReserva" id="ventanaReservaRealizada" style="background-color_: #EEEEEE; margin-bottom:20px;">
                      <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                        <label class="titReservaConfirmada_"
                          style="margin-top: 10px;
                                 margin-left: 10px;
                                 margin-bottom: 10px;
                                 font-size: 20px;
                                 font-weight: bold;"
                        
                        >{{ $t('reservaConfirmada') }}</label>
                      </v-row>

                      <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                        <label class="nombreParking" 
                          style="margin-top: 10px; margin-left: 10px;
                                 margin-bottom: 10px; font-size: 16px;">
                          {{ $t('inicioNombreParking') }}
                        </label>
                      </v-row>

                      <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                        <label class="txtInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: bold;">{{ $t('datosReservaFechaEntrada') }}</label>
                        <label class="datoInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: normal;">{{ fecha(datosReserva.fechaEntrada) }}</label>
                      </v-row>
        
                      <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                        <label class="txtInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: bold;">{{ $t('datosReservaFechaSalida') }}</label>
                        <label class="datoInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: normal;">{{ fecha(datosReserva.fechaSalida) }}</label>
                      </v-row>

                      <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                        <label class="txtInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: bold;">{{ $t('datosReservaMatricula') }}</label>
                        <label class="datoInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: normal;">{{ datosReserva.matricula }}</label>
                      </v-row>

                      <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                        <label class="txtInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: bold;">{{ $t('datosReservaLocalizador') }}</label>
                        <label class="datoInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: normal;">{{ datosReservaParking.locator }}</label>
                      </v-row>
               
                      <v-row cols="auto" class="mr-auto_ ml-auto" align="start" justify="start">
                        <label class="txtInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: bold;">{{ $t('datosReservaQR') }}</label>
                        <img style="margin-left: 30px" :src="datosReservaParking.imagenQR" width="200px" height="200px" contain_>
                      </v-row>

                      <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                        <p class="datoInfoReserva" style="margin-left: 10px; font-size: 14px; font-weight: normal;"><br>{{ $t('infoTiempoCortesia') }} </p>
                      </v-row>
                    
                    </div> 
                 
            

                  <v-btn
                    class="white--text"
                    color="#f08823"
                    @click="$router.push({ path: '/' })"
                  >
                    {{ $t('btnTerminar') }}
                  </v-btn>

                  <v-btn 
                    class="white--text"
                    color="#f08823"
                    @click="imprimir()"
                    style="margin-left: 10px"
                  >
                    {{ $t('btnImprimir') }}
                  </v-btn>

                </v-stepper-content> <!-- fin step 3 "reserva realizada" -->

              </v-stepper-items>

            </v-stepper> <!-- fin stepper -->

        </v-col> <!-- fin media fila izq. stepper --> 

        
        <v-col class="col-sm-4"> <!-- media fila der. informacion de la reserva solicitada-->
     
          <div class="">

            <!-- solo se pinta cuando se leen los datos almacenados en local storage -->
            <template v-if="cargado == true"> 

                <v-col class="columna">
                  <v-row cols="auto" class="mr-auto ml-auto tituloInfoReserva" align="center" justify="center">
                    {{ $t('resumenTitulo') }}
                  </v-row>
                  
                  <div class="infoReserva">

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="nombreParking">{{ $t('inicioNombreParking') }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaFechaEntrada') }}</label>
                      <label class="datoInfoReserva">{{ fecha(datosReserva.fechaEntrada) }}</label>
                    </v-row>
      
                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaFechaSalida') }}</label>
                      <label class="datoInfoReserva">{{ fecha(datosReserva.fechaSalida) }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaMatricula') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.matricula }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaTelefono') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.telefono }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaModelo') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.modelo }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaCrucero') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.crucero }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtPrecio">{{ $t('resumenPrecio') }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">

                      <label class="txtPrecio2">{{ $t('resumenSubTotal') }}</label>
                      <v-spacer></v-spacer>
                      <label class="subTotal">{{ datosReserva.importeReserva }}</label>

                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtPrecio2">{{ $t('resumenTotal') }}</label>
                      <v-spacer></v-spacer>
                      <label class="total">{{ calcularTotal() }}</label>
                    </v-row>
                  </div> 

                  <v-row cols="auto" class="mr-auto ml-auto pieInfoReserva" align="center" justify="center">
                    <font-awesome-icon class="iconoPieInfo" :icon="['fas', 'calendar-check']"/>           
                    {{ $t('resumenPieGarantia') }}
                  </v-row>

                  <v-row cols="auto" class="mr-auto ml-auto politicas" align="center" justify="start">
                    <router-link  
                      :to="{ name: 'aviso_legal', params: {tipoPagina: 0 } }"
                      style="margin-left: 5px;" class="mr-2_">
                      <span style="white-space:nowrap;">{{ $t('avisolegal') }}</span>
                    </router-link>
                    ,
                    <router-link 
                      :to="{ name: 'aviso_legal', params: {tipoPagina: 1 } }"
                      style="margin-left: 5px; margin-right: 5px;" class="mx-2_">
                      <span style="white-space:nowrap;">{{ $t('politicaDevolucion') }}</span>
                    </router-link>
                    {{ $t('y') }}
                    <router-link 
                      :to="{ name: 'aviso_legal', params: {tipoPagina: 2 } }" 
                      style="margin-left: 5px;" class="mx-2_">
                      <span style="white-space:nowrap;">{{ $t('politicaprivacidad') }}</span>
                    </router-link>

                  </v-row>

                  <v-row cols="auto" class="mr-auto ml-auto avisoCorreo text-justify" align="center" justify="start">
                    {{ $t('resumenAvisoCorreo') }}
                  </v-row>

                </v-col>

            </template>
            <template v-else> 
              <p>Cargando!!!</p> 
            </template>

          </div> <!-- fin titulo Completa tu reserva -->

      
     
     
     
     
     
     
     
        </v-col>  <!-- fin media fila der. informacion --> 
      
      </v-row>
    </v-container>





</template>


<style scoped>

  .tituloInfoReserva {
    padding: 10px;
    background-color: white;
    color: #4894ef;
    border-bottom: 1px solid rgb(240, 220, 220);
  }

  .infoTiempoReserva {
    padding: 10px;
    background-color: white;
    color: red;
    font-size: 20px;
    font-weight: bold;   
    border: 0px solid red;
  }
  
  .pieInfoReserva {
    padding: 10px;
    background-color: #4894ef;
    color: white;
  }

  .infoReserva {
    background-color: white;
    color: black;
  }

  .nombreParking {
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;

    font-size: 16px;
  }

  .titReservaConfirmada {
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;

    font-size: 20px;
    font-weight: bold;
  }

  .txtInfoReserva {
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
  }

  .datoInfoReserva {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
  }

  .txtPrecio {
    margin-left: 10px;
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
  }

  .txtPrecio2 {
    margin-left: 10px;
    margin-top: 0px;
    font-size: 16px;
    font-weight: bold;
  }


  .subTotal{
    margin-left: 10px;
    margin-right: 10px;
    font-size: 10px;
  }

  .total{
    margin-left: 10px;
    margin-right: 10px;
    font-size: 40px;
    color:#4894ef;
    font-weight: bold
  }

  .iconoPieInfo{
    font-size:25px;
    color:white; 
    margin-right: 10px;
  }

  .politicas{
    margin-top: 20px;
    font-size: 12px;
    font-weight: normal;
    color: #4894ef;
  }

  .avisoCorreo{
    margin-top: 20px;
    font-size: 12px;
    font-weight: bold;
    color: black;
  }

  .contacto{
    margin-top: 20px;
    font-size: 12px;
    font-weight: normal;
    color: black;
  }


 .entradaDatosUnico {
    margin-left: 0px;
    margin-right: 0px;
  }

 .desplegableDatosFacturacion {
    margin-left: 2%;
    margin-right: 2%;
  }


</style>




<script>
// comunicacion HTTP con RestApi
import axios from "axios";

// constantes para todo el proyecto
import { escribirLog, generarUrlBase, codinsclo } from '@/plugins/utilidades.js'


// validacion de formularios
import { required, email /*, minLength, sameAs*/ } from "vuelidate/lib/validators";


export default {
  name: "PaginaContinuarReserva",

  data: () => ({

    countDown: '',

    //indica si se ha pulsado el boton de aceptar formulario
    submitted: false,

    // indicador de que se ha recuperado los datos de reserva de localStorage    
    cargado: false, 

    // indicador de avance stepper procesoPago    
    procesoPago: 1, 

    reservaSinPagar: false,

    dialog: false,

    // titulo de la pagina cargada en el iframe
    tituloPagina: '',
    
    // url de pago en PayComet
    urlPago: '',
  
    codigoDescuento: {
      codigo: '',
      importe: 0
    }, // fin objeto codigoDescuento

    alerta: {
      mostrar: false,
      texto: ''
    }, //fin objeto alerta

    datosReserva: {
      importeReservaNumero: 0,
      importeReserva: "",
      horaEntrada: "00:00",
      fechaEntrada: null,
      horaSalida: "00:00",
      fechaSalida: null,
      matricula: "",
      modelo: "",
      color: "",
      crucero: "",
      idClienteBD: 0,
      nombre: "",
      mail: "",
      telefono: "",
      nombreFac: "",
      cif: "",
      direccion: "",
      localidad: "",
      cp: "",
      pais: "",
      aceptacionTerminos: "",
      idReservaBD: -1,
      merchant_order: ""
    }, // fin objeto data.datosReserva 

    datosReservaParking: {
      locator: "", 
      barcode: "",
      barcode_type: "",
      description: "",
      door_pinpad_key: "",
      id: "",
      media_type: 0,
      number: "",
      imagenQR: ""
    }, // fin objeto data.datosReservaParking 
  }),
  
  validations: {
    datosReserva: {
      nombre: { required },
      mail: { required, email },
      telefono: { required },
      aceptacionTerminos: {
          required (val) {
            return val
          }
      }                
    }
  },  // validacion de formularios con vuelidation

  methods: {
    fecha: function(aFecha){
      // devuelve formateadas y traducidad las fechas de entrada y salida

      var txtFecha = '';
      var ffecha = this.$moment(aFecha);

      if ('en' == this.$i18n.locale){
        txtFecha = ffecha.locale(this.$i18n.locale).format("dddd, MMMM Do YYYY, HH:mm");
      } else {
        txtFecha = ffecha.locale(this.$i18n.locale).format("dddd, DD MMMM YYYY, HH:mm");
      }

      return txtFecha;

    }, // fin metodo fecha

    calcularTotal: function(){
      // el total a pagar es el importe menos el descuento
      //escribirLog('calcularTotal: ' + this.datosReserva.importeReserva);
      //escribirLog(this.codigoDescuento.importe);
      
      var elTotal = this.datosReserva.importeReservaNumero - this.codigoDescuento.importe;
      return elTotal + '€';
    }, //fin metodo calcularTotal

    guardarReservaBD: function (){
      /* Almacenamiento de los datos de la reserva 
        en la base de datos. */

      escribirLog('Consulta guardarReservaBD');

      const datosPeticion = {
					"codinsclo": codinsclo,
					"id_cliente": this.datosReserva.idClienteBD,
          "id_tarjeta": -1,
          "fecha_alta": this.$moment().toISOString(true),
					"inicio": this.$moment(this.datosReserva.fechaEntrada).toISOString(true),
					"final": this.$moment(this.datosReserva.fechaSalida).toISOString(true),
					"localizador": "", 
					"codigo_barras": "", 
					"tipo_codigo": "",
					"descripcion_producto": "", 
					"clave_pinpad": "", 
					"numero_producto": "", 
					"matricula": this.datosReserva.matricula,
					"importe": this.datosReserva.importeReservaNumero,
					"DS_MERCHANT_ORDER": "",
          "email": this.datosReserva.mail,
          "modelo": this.datosReserva.modelo,
          "color": this.datosReserva.color,
          "crucero": this.datosReserva.crucero,
          "nombre": this.datosReserva.nombre,
          "telefono": this.datosReserva.telefono,
          "nombreFac": this.datosReserva.nombreFac,
          "cif": this.datosReserva.cif,
          "direccion": this.datosReserva.direccion,
          "localidad": this.datosReserva.localidad,
          "cp": this.datosReserva.cp,
          "idioma": this.$i18n.locale.toUpperCase(),
          "availability_request_token": window.localStorage.getItem("availability_request_token"),
          };

      escribirLog(datosPeticion);

      const cabeceras = {
        'Content-Type': 'application/json; charset=utf-8'
      }

      // orden al backend de almacenamiento de datos de reserva en BD
      axios
        .post(generarUrlBase() + '/restapi/BD/nuevaReserva', 
              datosPeticion,
              { headers: cabeceras})
        .then(response => {
          escribirLog('Respuesta guardarReservaBD');
          escribirLog(response);

          if (1 == response.data.creado) {
          /* reserva salvada en BD. Hay que realizar el cargo. Para ello se obtiene la url de
            pago, se selecciona la url en el iframe y se avanza el stepper */
            this.datosReserva.idReservaBD = response.data.id_reserva;
            this.obtenerURLPago();
            
          } else {
          // reserva NO salvada en BD. Hay que borrar la solicitud de reserva en el parking
            this.alerta.mostrar = true;
            this.alerta.texto = response.data.error_message;
          }

        })
        .catch(error => {
          escribirLog('Error guardarReservaBD')
          escribirLog(error);

          // Error salvando reserva en BD. Hay que borrar la solicitud de reserva en el parking
          this.alerta.mostrar = true;
          this.alerta.texto = error;
        })
        .finally(() => { 
          escribirLog('Final guardarReservaBD');

        })
    }, // fin metodo guardarReservaBD

    obtenerURLPago: function (){
      var parametros= {
        'codinsclo': codinsclo,
        'id_reserva': this.datosReserva.idReservaBD,
        'matricula': this.datosReserva.matricula,
				'importe': this.datosReserva.importeReservaNumero,
        'idioma': this.$i18n.locale.toUpperCase()
      }
      
      const cabeceras = {
      }

      escribirLog(parametros);
   
      axios
        .get(generarUrlBase() + '/restapi/paycomet/obtenerURLIframePagoTarjeta', 
              { params: parametros,
                headers:cabeceras
              }
        )                
        .then(response => {
          escribirLog('Respuesta obtenerURLPago');
          escribirLog(response.data);


          this.dialog = false;
          this.urlPago = response.data.url;
          // avanzo el stepper
          this.procesoPago = 2;
          window.scrollTo(0,0);

        })
        .catch(error => {
          escribirLog('Error obtenerURLPago')
          escribirLog(error)

          this.alerta.mostrar = true;
          this.alerta.texto = error;

        })
        .finally(() => { 
          escribirLog('Final obtenerURLPago');

        }) 
    }, // fin metodo obtenerURLPago

    callback_cancelarReserva: function(){
      this.dialog = false;
      this.procesoPago = -1;   
      // cambio de pagina
      this.$router.push({ path: '/reservar' })          
    },  // fin metodo callback_cancelarReserva

    cancelarReservaEnCurso: function(){   
      this.dialog = false;
      this.procesoPago = -1;   
      // cambio de pagina
      this.$router.push({ path: '/reservar' })
    },  // fin metodo cancelarReservaEnCurso
   
    comprobarDatosUsuario: function (){
      /* comprobacion de que los datos del formulario son correctos 
        antes de continuar con el proceso de reserva */

      this.submitted = true;

      escribirLog(this.datosReserva);

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        escribirLog('invalido');
        return;
      }

       window.localStorage.setItem("nombre", this.datosReserva.nombre);
       window.localStorage.setItem("mail", this.datosReserva.mail);
       window.localStorage.setItem("telefono", this.datosReserva.telefono);

       window.localStorage.setItem("direccion", this.datosReserva.direccion);
       window.localStorage.setItem("localidad", this.datosReserva.localidad);
       window.localStorage.setItem("cp", this.datosReserva.cp);
       window.localStorage.setItem("pais", this.datosReserva.pais);
       window.localStorage.setItem("nombreFac", this.datosReserva.nombreFac);
       window.localStorage.setItem("cif", this.datosReserva.cif);

      this.dialog = true;

      this.guardarReservaBD();
    }, // fin metodo comprobarDatosUsuario

    paginaFrameCargada: function() {
      /* Cuando puedo obtener el titulo de la pagina web cargada en en iFrame es por que
         se trata de una de las páginas de mi dominio operacionOk u operacionKo.
      
         Es mucho mas fiable que contar el numero de eventos onLoad, ya que no se cuantos 
         se van a producir con el pago seguro.  

         Solo escribo el nuevo titulo en caso de que la cadena anterior esté vacia
      */

      var oIframe = document.getElementById("iframePago");
      if ((undefined != oIframe.contentWindow) && ( null != oIframe.contentWindow)){
        if (this.tituloPagina == '')
          this.tituloPagina = oIframe.contentWindow.document.title;
      }

      escribirLog("Titulo pagina en iframe: " + this.tituloPagina);

    }, // fin metodo paginaFrameCargada

    finalizarReserva: function(){

      escribirLog('Consulta ObtenerReserva');
      var parametros= {
        'mail': this.datosReserva.mail,
        "id_reserva": this.datosReserva.idReservaBD,
        'estado': 0,
      };

      const cabeceras = {
      };

      axios
        .get(generarUrlBase() + '/restapi/BD/obtenerReserva', 
              { params: parametros,
                headers:cabeceras
              })
        .then(response => {
          escribirLog('Respuesta ObtenerReserva');
          escribirLog(response);

          if ((1 == response.data.existe) && (0 == response.data.reserva.estado)){
            // la reserva existe y se ha pagado correctamente
            escribirLog(response.data);

            this.datosReservaParking.locator = response.data.reserva.localizador; 
            this.datosReservaParking.imagenQR = response.data.imagenQR;

            // cambio el stepper
            this.procesoPago = 3;        
            window.scrollTo(0,0);
                
          } else {
            // cambio el stepper
            this.procesoPago = 1;  
           window.scrollTo(0,0);
      
          }

        })
        .catch(error => {
          escribirLog('Error ObtenerReserva');
          escribirLog(error);
        })
        .finally(() => { 
          escribirLog('Final ObtenerReserva');
          this.urlPago = "";
          document.querySelector("iframePago").contentWindow.location.replace("about:blank");
        })

    }, // fin metodo finalizarReserva  

    imprimir: function() {
      this.$htmlToPaper('ventanaReservaRealizada');
    },

    procesoUnload: function() {
      escribirLog('procesoUnload PaginaContinuarReserva.vue');
    },
    

    formAction:	function(){
      var myForm = document.getElementById("paycometPaymentForm");
      escribirLog(myForm);
    },
    
    countDownTimer: function() {
      var fechaLimiteISO = window.localStorage.getItem("availability_request_expiration_time");      
      var fechaLimite = this.$moment(fechaLimiteISO);      


      var ahora = this.$moment();
      var duracion = this.$moment.duration(fechaLimite.diff(ahora));

      var min = duracion._data.minutes;
      if (min<10)
        min = '0' + min;

      var seg = duracion._data.seconds;
      if (seg < 10)
        seg = '0' + seg;
        
      if ((duracion > 0) && (this.tituloPagina == '')) {
          setTimeout(() => {
              this.countDown = min + ':' + seg;
              this.countDownTimer();
          }, 1000)
      } else {
        if (this.tituloPagina == '')
          this.$router.push({ path: '/' });
      }
    },  // fin metodo countDownTimer

  }, // fin methods




  mounted: function() {
    this.countDownTimer();
        
    // recuperamos los datos de la reserva almacenados en local por la pantalla anterior
    this.datosReserva.importeReserva = window.localStorage.getItem("importeReserva");
    this.datosReserva.importeReservaNumero = window.localStorage.getItem("importeReservaNumero");
    // las fechas de entrada/salida incluyen la informacion de la hora
    this.datosReserva.fechaEntrada = window.localStorage.getItem("fechaEntrada");
    this.datosReserva.fechaSalida = window.localStorage.getItem("fechaSalida");
    this.datosReserva.matricula = window.localStorage.getItem("matricula");
    this.datosReserva.modelo = window.localStorage.getItem("modelo");
    this.datosReserva.color = window.localStorage.getItem("color");
    this.datosReserva.crucero = window.localStorage.getItem("crucero");
    this.datosReserva.nombre = window.localStorage.getItem("nombre");
    this.datosReserva.mail = window.localStorage.getItem("mail");
    this.datosReserva.telefono = window.localStorage.getItem("telefono");

    this.datosReserva.direccion = window.localStorage.getItem("direccion") == "null" ? "" : window.localStorage.getItem("direccion");
    this.datosReserva.localidad = window.localStorage.getItem("localidad") == "null" ? "" : window.localStorage.getItem("localidad");
    this.datosReserva.cp = window.localStorage.getItem("cp") == "null" ? "" : window.localStorage.getItem("cp");
    this.datosReserva.pais = window.localStorage.getItem("pais") == "null" ? "" : window.localStorage.getItem("pais") ;
    this.datosReserva.nombreFac = window.localStorage.getItem("nombreFac") == "null" ? "" : window.localStorage.getItem("nombreFac");
    this.datosReserva.cif = window.localStorage.getItem("cif") == "null" ? "" : window.localStorage.getItem("cif");
 
    escribirLog('mounted');
    escribirLog(window.localStorage.getItem("idReservaSinPagar"));
    escribirLog(window.localStorage.getItem("locatorSinPagar"));
    escribirLog(window.localStorage.getItem("codinscloSinPagar"));

    this.cargado = true;
    escribirLog(this.datosReserva);
    
    escribirLog("scroll");
    window.scrollTo(0,0);
  }, // fin evento mounted

  beforeDestroy: function(){
    /* captura del evento beforeDestroy de la pagina para detectar cuando se abandona 
       via router.
    */    
      
     escribirLog('beforeDestroy PaginaContinuarReserva.vue');
  },// fin evento beforeDestroy

  created() {
    /* programo un sistema de captura del evento beforeunload para detectar cuando se 
       refresca la pagina. */
    window.addEventListener('beforeunload', this.procesoUnload)
  },// fin evento created
  

};
</script>
